// extracted by mini-css-extract-plugin
export default {"filter":"PatientDoctors_filter__rkbGP"};